import { useMutation, useQueryClient } from '@tanstack/react-query'
import { httpDeleteRoadmapActivity } from '@/features/roadmaps/http/roadmap.http'
import { MUTATION_KEYS, QUERY_KEYS } from '@/query-client'

interface UseDeleteRoadmapActivityProps {
	onSuccess?: () => void
	onError?: (error: unknown) => void
}

export const useDeleteRoadmapActivity = (
	options?: UseDeleteRoadmapActivityProps
) => {
	const queryClient = useQueryClient()

	return useMutation({
		mutationKey: [MUTATION_KEYS.DELETE_ROADMAP_ACTIVITY],
		mutationFn: (title: string) => httpDeleteRoadmapActivity(title),
		onError: (error) => options?.onError?.(error),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: [QUERY_KEYS.GET_ROADMAP_ACTIVITIES]
			})
			options?.onSuccess?.()
		}
	})
}
